module.exports = __webpack_public_path__ + "img/pic_chumanyi1.4400e319.png";